export let NewsroomGallery;
(function (_NewsroomGallery) {
  let Status = /*#__PURE__*/function (Status) {
    Status["PRIVATE"] = "private";
    Status["PUBLIC"] = "public";
    return Status;
  }({});
  _NewsroomGallery.Status = Status;
  let Type = /*#__PURE__*/function (Type) {
    Type["IMAGE"] = "image";
    Type["VIDEO"] = "video";
    return Type;
  }({});
  _NewsroomGallery.Type = Type;
})(NewsroomGallery || (NewsroomGallery = {}));